module.exports = "./img/85da9a9287887635fd7c728de541556e.png";